import { ActionIcon, Card, Stack, Table, Text } from '@mantine/core'
import { formatDate, formatEuros } from '@markku/utils'
import { IconEdit } from '@tabler/icons-react'
import { CostItem } from './utils'

interface CostsItemsTableProps {
  items: CostItem[]
  onEdit: (item: CostItem) => void
}

export function CostsItemsTable({ items, onEdit }: CostsItemsTableProps) {
  if (!items.length) return null

  return (
    <Card withBorder radius="lg" p="md">
      <Stack gap="md">
        <Text fw={600} size="sm">
          Kustannuserittely
        </Text>

        <Table.ScrollContainer minWidth={500}>
          <Table>
            <Table.Thead>
              <Table.Tr>
                <Table.Th>Päivämäärä</Table.Th>
                <Table.Th>Tehtävä</Table.Th>
                <Table.Th>Kategoria</Table.Th>
                <Table.Th>Budjetoitu</Table.Th>
                <Table.Th>Toteutunut</Table.Th>
                <Table.Th></Table.Th>
              </Table.Tr>
            </Table.Thead>
            <Table.Tbody>
              {items.map((item) => (
                <Table.Tr key={item.id}>
                  <Table.Td>
                    <Text size="sm">
                      {item.date ? formatDate(item.date) : '-'}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Stack gap={2}>
                      <Text size="sm" fw={500}>
                        {item.name}
                      </Text>
                      {item.description && (
                        <Text size="xs" c="dimmed" lineClamp={1}>
                          {item.description}
                        </Text>
                      )}
                    </Stack>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm">{item.category}</Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm">
                      {item.budget ? formatEuros(item.budget) : '-'}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <Text size="sm" fw={item.actual ? 600 : undefined}>
                      {item.actual ? formatEuros(item.actual) : '-'}
                    </Text>
                  </Table.Td>
                  <Table.Td>
                    <ActionIcon variant="subtle" onClick={() => onEdit(item)}>
                      <IconEdit size={16} />
                    </ActionIcon>
                  </Table.Td>
                </Table.Tr>
              ))}
            </Table.Tbody>
          </Table>
        </Table.ScrollContainer>
      </Stack>
    </Card>
  )
}
